import siteConfig from '@/config/site';

const base = siteConfig.siteUrl;

function meta(title, description, keywords, path) {
  return {
    appname: siteConfig.siteName,
    title,
    keywords: keywords || '',
    description,
    link: [{ rel: 'canonical', href: `${base}${path}` }],
  };
}

export default {
  bloglist: {
    en: [
      {
        title: 'WhatsApp Aero vs Official WhatsApp – Full Comparison',
        navTitle: 'Official WhatsApp',
        poster: require('@/assets/aero/aero-shot-1.webp'),
        desc: 'Compare WhatsApp Aero with official WhatsApp. Discover differences in privacy, customization, media sharing, and user control features.',
        name: 'en-blog-vs-wa',
        url: '/blog/whatsapp-vs-aero/',
        date: '2026-07-09',
      },
      {
        title: 'WhatsApp Aero vs GB WhatsApp – Which Is Better?',
        navTitle: 'GB WhatsApp',
        poster: require('@/assets/aero/aero-shot-2.webp'),
        desc: 'Detailed comparison between WhatsApp Aero and GB WhatsApp including features, performance, customization, and stability.',
        name: 'en-blog-vs-gb',
        url: '/blog/aero-vs-gbwhatsapp/',
        date: '2026-07-09',
      },
      {
        title: 'WhatsApp Aero for iOS – Is It Available or Not?',
        navTitle: 'iOS',
        poster: require('@/assets/aero/aero-shot-4.webp'),
        desc: 'Learn whether WhatsApp Aero works on iPhone and explore safe alternatives for iOS users with similar customization features.',
        name: 'en-blog-ios',
        url: '/blog/ios/',
        date: '2026-07-09',
      },
    ],
  },
};

export { meta };
